import React, { useState, useEffect, useCallback } from 'react';
import SettingsIcon from 'src/assets/images/common/settings.svg';
import CheckBox from 'src/components/Form/checkbox';
import RadioButton from 'src/components/Actions/radioButton';
import Popover from '@mui/material/Popover';
// import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Collapse from 'react-bootstrap/Collapse';
import Box from '@mui/material/Box';
import DownArrow from 'src/assets/images/common/collapse-down.svg';
import RightArrow from 'src/assets/images/common/collapse-right.svg';
import { usePayloadContext } from 'src/contexts/PayloadContext';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import DraggableItem from 'src/components/Actions/draggableItem';
import useApi from 'src/hooks/useApi';
import services from 'src/api/service';
import DroppableContainer from 'src/components/Actions/drabbleContainer';
import MetricsDrag from './metics-drag';
import TablesDrag from './tables-drag';
import { sweetAlertHandler } from 'src/views/pages/targetting/toaster';
import Spinner from 'react-bootstrap/Spinner';
import { Loader } from 'src/views/pages/dashboards';
import { useTargetingContext } from 'src/contexts/TargetingContext';
// import { isFlipkart } from 'src/utils/utils';
import {  Modal,Button } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { idb } from 'src/utils/idb';
import { is } from 'date-fns/locale';
import CustomTablesDrag from './tables-drag-v2';
import WarningIcon from 'src/assets/icons/WarningIcon';

export default function TableSettings() {

  const [defaultView, setDefaultView] = useState(0);
  const { targetingState, targetingDispatch } = useTargetingContext()
  const [anchorEl, setAnchorEl] = useState(null);
  const [masterColumns, setMasterColumns] = useState([]);
  const [selectedOption, setSelectedOption] = useState('metrics');
  const [rotationAngle, setRotationAngle] = useState(0);
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const isMarketingStream = window.location.href.indexOf('marketing-stream') > -1;
  const isAmazon = window.location.href.indexOf('amazon') > -1;
  const isFlipkart = window.location.href.indexOf('flipkart') > -1
  const isInstamart = window.location.href.indexOf('instamart') > -1
  const isMyntra = window.location.href.indexOf('myntra') > -1;
  const isBlinkit = window.location.href.indexOf('blinkit') > -1;
  const deleteApiCall = useApi(services.postService);
  const [showModal, setShowModal] = useState(false);
  const isZepto = window.location.href.indexOf('zepto') > -1;
  const isBigbasket = window.location.href.indexOf('bigbasket') > -1;

  const handleCloseModal = () => setShowModal(false);

  const isAmazonTargeting = window.location.href.indexOf('/amazon/targeting') > -1;
  const isAMSTargeting = window.location.href.indexOf('amazon/marketing-stream') > -1;
  const isSQPTargeting = window.location.href.indexOf('amazon/search-query-performance') > -1;
  const isRanking = window.location.href.indexOf('/amazon-ranking-dashboard') > -1;


  const clientPreference = (isAmazon || isRanking) ? 'selectedProfileId' : isMyntra ? 'myntraProfile' : isBlinkit ? 'blinkitProfile' : isInstamart ? 'instamartProfile' : isZepto ? 'zeptoProfile' : isBigbasket ? 'bigbasketProfile'  : 'flipkartProfile';
  const profileDetails = sessionStorage.getItem(clientPreference);
  const profileId = profileDetails ? JSON.parse(profileDetails).profileId : null;


  const [metricsList, setMetricsList] = useState([]);
  const [tablesList, setTablesList] = useState([]);
  const [customTableAlert, setCustomTableAlert] = useState(false);
  const [initialTablesSnapshot, setInitialTablesSnapshot] = useState('');
  const [initialMetricsSnapshot, setInitialMetricsSnapshot] = useState('');

  const updateDataToMetrics = (newData) => {
    console.log("updateDataToMetrics", newData)
    setMetricsList([...newData])
  }

  const updateDataToTables = (newData) => {
    console.log("updateDataToTables", newData)
    setTablesList([...newData])
  }

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleClick = (event) => {
    fetchTableListSetting.request({
      url: '/user-default/list-default-records',
      nodeAPI: 1,
      payload: {
        report: (isAmazon && isAmazonTargeting) ? 'amazon' : (isAmazon && isAMSTargeting) ? 'marketing-stream' : isMyntra ? 'myntra' : isBlinkit ? 'blinkit' : isFlipkart ? 'flipkart' : isInstamart ? 'instamart' : isZepto ? 'zepto' : isBigbasket ? 'bigbasket' : (isAmazon && isSQPTargeting) ? 'sqp' : isRanking ? 'ranking' : '',
      }
    });
    setAnchorEl(event.currentTarget);
    const newRotationAngle = rotationAngle + 40;
    setRotationAngle(anchorEl === 'null' ? -40 : newRotationAngle);
    setSelectedOption('metrics');
    if(targetingState?.columns && targetingState?.columns?.length > 0) {
      setMetricsList(targetingState?.columns);
      setInitialMetricsSnapshot(JSON.stringify(targetingState.columns));
    }
    if(targetingState?.table_groups && targetingState?.table_groups?.length > 0) {
      setTablesList(targetingState?.table_groups)
      // Capture initial snapshot (order + visibility)
      setInitialTablesSnapshot(JSON.stringify(targetingState.table_groups));
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const fetchTableListSetting = useApi(services.postService);
  const saveTableListSetting = useApi(services.postService);
  const [apiSetingInfo, setApiSettingsInfo] = useState({}) 

  const tableConfigParam = (isAmazon && isAmazonTargeting) ? 'tableListConfig' : ( isAmazon && isAMSTargeting ) ? 'tableListAmsConfig' : (isAmazon && isSQPTargeting) ? 'tableListSqpConfig' : isFlipkart ? 'flipkartTableListConfig' : isMyntra ? 'myntraTableListConfig' : isInstamart ? 'instamartTableListConfig' : isBlinkit ? 'blinkitTableListConfig' : isZepto ? 'zeptoTableListConfig' : isBigbasket ? 'bigbasketTableListConfig'  : ''
  const metricsConfigParam = ( isAmazon && isAmazonTargeting ) ? 'amazonMetrics': ( isAmazon && isAMSTargeting ) ? 'amazonAMSMetrics' : (isAmazon && isSQPTargeting) ? 'amazonSQPMetrics' : isFlipkart ? 'flipkartMetrics' : isMyntra ? 'myntraMetrics' : isInstamart ? 'instamartMetrics' : isBlinkit ? 'blinkitMetrics' : isZepto ? 'zeptoMetrics' : isBigbasket ? 'bigbasketMetrics' : ''

  function getVisibleTablesMap(groups) {
    const result = {};
    
    for (const group of groups ?? []) {
      for (const table of group?.table ?? []) {
        if ((table?.show || "").toLowerCase() !== "yes") continue;
        const key =
          table?.custom === 1
            ? table?.customDetails?.table_id
            : table?.payload?.aggregate;
        if (!key) continue; // skip if no key derivable
        result[key] = true;
      }
    }
  
    return result;
  }

  const updateTableCacheSettings = (tables) => {
    targetingDispatch({
      type: 'UPDATE_TARGETING_SETTINGS',
      payload: tables
    });
  }
  
  const onUpdateSettings = React.useCallback(async () => {
    if (selectedOption === 'tables') {
      console.log("tablesList", tablesList);
      try {
        await idb.setTableConfig(profileId, tablesList);
        targetingDispatch({
          type: 'UPDATE_TABLE_GROUPS',
          payload: tablesList
        });
        if (isAmazonTargeting) {
          updateTableCacheSettings(getVisibleTablesMap(tablesList));
        }
        // if(defaultView) 
          saveTablesAndMetrics();
      } catch (error) {
        console.error('Error saving tables to IDB:', error);
      }
    } else if (selectedOption === 'metrics') {
      console.log("metricsList", metricsList);
      try {
        await idb.setMetricsConfig(profileId, metricsList);
        targetingDispatch({
          type: 'UPDATE_TABLE_COLUMNS',
          payload: metricsList
        });
        // if(defaultView) 
          saveTablesAndMetrics();
      } catch (error) {
        console.error('Error saving metrics to IDB:', error);
      }
    }
    handleClose();
  }, [
    selectedOption,
    tablesList,
    metricsList,
    profileId,
    targetingDispatch,
    isAmazonTargeting,
    updateTableCacheSettings,
    getVisibleTablesMap,
    handleClose,
    defaultView
  ]);

  const saveTablesAndMetrics = useCallback(async () => {
    try {
        // Save metrics to IndexedDB
        await idb.setMetricsConfig(profileId, metricsList);
        
        // Save tables to IndexedDB
        await idb.setTableConfig(profileId, tablesList);

        // Update the targeting context
        targetingDispatch({
            type: 'UPDATE_TABLE_GROUPS',
            payload: tablesList
        });

        targetingDispatch({
            type: 'UPDATE_TABLE_COLUMNS',
            payload: metricsList
        });

        // Save to backend
        saveTableListSetting.request({
            url: '/user-default/create-or-update-records',
            nodeAPI: 1,
            payload: {
                report: 
                        String(window.location.href).indexOf('amazon-ranking-dashboard') > -1 ? 'ranking' :
                        String(window.location.href).indexOf('amazon') > -1 ? 'amazon' : 
                        String(window.location.href).indexOf('myntra') > -1 ? 'myntra' : 
                        String(window.location.href).indexOf('instamart') > -1 ? 'instamart' : 
                        String(window.location.href).indexOf('blinkit') > -1 ? 'blinkit' : 
                        String(window.location.href).indexOf('flipkart') > -1 ? 'flipkart' : 
                        String(window.location.href).indexOf('marketing-stream') > -1 ? 'marketing-stream' :
                        String(window.location.href).indexOf('zepto') > -1 ? 'zepto' :
                        String(window.location.href).indexOf('bigbasket') > -1 ? 'bigbasket' :
                        String(window.location.href).indexOf('search-query-performance') > -1 ? 'sqp' : '',
                table: tablesList,
                metric: metricsList
            }
        });
    } catch (error) {
        console.error('Error saving to IndexedDB:', error);
    }
  }, [profileId, tablesList, metricsList]);

  useEffect(() => {

    const { loading, data } = saveTableListSetting

    if(!loading && data && data?.success == true) {
      setTimeout(() => {
        setDefaultView(0)
        handleClose()
        sweetAlertHandler({ 
          type: 'alert', 
          text: 'Default setting view updated !', 
          showConfirmButton: false, 
          timer: 3000,
          customClass: {
            title: 'mb-2'
          }
        })
      }, 100);


    }

  }, [saveTableListSetting.loading])


  useEffect(() => {
    const { loading, data } = fetchTableListSetting;
    if (!loading && data) {
      const response = { table: data?.result?.table || [], metric: data?.result?.metric || [] };
      setApiSettingsInfo(response)
    }
  }, [fetchTableListSetting.loading])

  const removeProfileFromMetricsAndTables = async () => {
    try {
      await idb.deleteMetricsConfig(profileId);
      await idb.deleteTableConfig(profileId);
    } catch (error) {
      console.error('Error removing from IDB:', error);
    }
  };

  const handleDeleteApi = async () => {
    deleteApiCall.request({
      url: '/user-default/delete-default-records',
      nodeAPI: 1,
      payload: {
        report: isRanking ? 'ranking' : isSQPTargeting ? 'sqp' : isMarketingStream? 'marketing-stream' : isAmazon ? 'amazon' : isMyntra ? 'myntra' : isBlinkit ? 'blinkit' : isInstamart ? 'instamart' : isFlipkart ? 'flipkart' : isZepto ? 'zepto' : isBigbasket ? 'bigbasket' : '',
      },
    });
    removeProfileFromMetricsAndTables();
  }

  useEffect(() => {
    const { loading, data } = deleteApiCall;
    if (!loading && data) {
        setShowModal(false);
        Swal.fire({
          icon: 'success',
          title: 'Reset to Default Successfully Completed',
          text: 'The profile has been reset to default settings.',
          showConfirmButton: false,
          timer: 1000,
        });
        sessionStorage.removeItem('cacheTargetingSettings');
        setTimeout(() => {
          window.location.reload();
        }, 1000);
    }
  }, [deleteApiCall.loading]);

  const [metricListChangeDetect, setMetricChangeDetect] = useState(false);
  const [tableListChangeDetect, setTableListChangeDetect] = useState(false);
  const [isAllMetricsTurnedOff, setIsAllMetricsTunedOff] = useState(false);
  const [isAllTableTurnedOff, setIsAllTableTurnedOff] = useState(false);
 
  // Compare table visibility and order changes
  const handleTableConfigChange = (
    tablesList,
    initialTablesSnapshot,
    setTableListChangeDetect
  ) => {
    if (!initialTablesSnapshot) {
      setTableListChangeDetect(false);
      return { hasChanges: false };
    }

    const currentSnapshot = JSON.stringify(tablesList);
    const hasChanges = currentSnapshot !== initialTablesSnapshot;
    
    setTableListChangeDetect(hasChanges);
    return { hasChanges };
  };

  useEffect(() => {
    console.log("DetectMetricsListChange");
    if (!initialMetricsSnapshot) {
      setMetricChangeDetect(false);
      return;
    }
    setMetricChangeDetect(JSON.stringify(metricsList) !== initialMetricsSnapshot);
  }, [metricsList, initialMetricsSnapshot]);

  useEffect(() => {
    console.log("DetectTableListChange", tablesList, initialTablesSnapshot);
    handleTableConfigChange(tablesList, initialTablesSnapshot, setTableListChangeDetect);
  }, [tablesList, initialTablesSnapshot]);

  useEffect(() => {
    console.log("DetectMetricsListOff");
    setIsAllMetricsTunedOff(
      selectedOption === "metrics" &&
        metricsList?.filter((item) => item.show === "yes").length === 0 ? true : selectedOption === "metrics" &&
        targetingState?.columns?.filter((item) => item.show === "yes").length === 0 ? true : false
    );
  }, [selectedOption, metricsList, targetingState?.columns]);

  useEffect(() => {
    const allTableTurnedOff = selectedOption === "tables" &&
    tablesList?.filter(
      (item) => item.table.filter((item) => item.show === "yes").length > 0
    ).length === 0 ? true : selectedOption === "tables" &&
    targetingState?.table_groups?.filter(
        (item) => item.table.filter((item) => item.show === "yes").length > 0
      ).length === 0 ? true : false
    console.log("DetectTableListOff", tablesList, allTableTurnedOff);
    setIsAllTableTurnedOff(allTableTurnedOff);
  }, [selectedOption, tablesList, targetingState?.table_groups]);
  
  
const defaultSelect = () => {
  handleClose();
  setShowModal(true);
}

  return (
    
    <div>
      <IconButton aria-label="SettingsIcon" aria-describedby={id} onClick={handleClick}>
        <img
          src={SettingsIcon}
          alt="table-settings"
          className="cursor-pointer wid-20"
          style={{
            transform: `rotate(${rotationAngle}deg)`,
            transition: 'transform 0.3s ease'
          }}
        />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right'
        }}
        PaperProps={{
          style: {
            borderRadius: '8px',
            width: isAmazon ? '300px' : '250px',
            maxHeight: '500px',
            overflow: 'visible'
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            zIndex: '-10',
            '&::before': {
              backgroundColor: '#4E4E4E',
              content: '""',
              display: 'block',
              position: 'absolute',
              width: 10,
              height: 10,
              top: -4,
              transform: 'rotate(45deg)',
              left: 'calc(93% - 6px)'
            }
          }}
        />
        {/* HEADER */}
        <div style={{ position: 'relative' }}>
          <div className="settings_table_header">
            Table Display Settings
            <span className="cursor-pointer f-14" onClick={handleClose}>
              &#x2715;
            </span>
          </div>
        </div>
        {/* HEADER */}

        <section className='position-relative'>

          <div  className='d-flex align-items-center justify-content-end  gap-8 mt-2 mr-2'>
          {/* <p className='f-10'>Reset to Default</p> */}
          <a onClick={defaultSelect} className='f-10 cursor-pointer ' style={{color:'#1877f2',textDecoration:'underline'}}>Reset to Default</a> 
          </div>

          {/* DEFAULT VIEW */}
          {/* {!fetchTableListSetting.loading && !saveTableListSetting.loading && (metricListChangeDetect || tableListChangeDetect) && !isAllMetricsTurnedOff && !isAllTableTurnedOff ? <div className="settings_default_view">
            <CheckBox label="Set my default view" action={(event) => {
                setDefaultView(event.target && event.target.checked === true ? 1 : 0)
            }} classes="f-10" />
            <p className={`save_button ${!defaultView || saveTableListSetting.loading || isAllMetricsTurnedOff || isAllTableTurnedOff ? 'disabled' : ''}`} onClick={onUpdateSettings}>Save</p>
          </div> : null} */}
          {/* DEFAULT VIEW */}
          
          {/* ALERT SECTION */}
          {customTableAlert && (
              <>
                <div 
                  className="custom-table-alert-backdrop"
                  onClick={() => {
                    setCustomTableAlert(false);
                  }}
                />
                <div className="custom-table-alert-message">
                  <WarningIcon />
                  <span>You can select up to 2 custom tables per group.</span>
                </div>
              </>
            )}
          {/* ALERT SECTION */}
        </section>
        {/* RADIO BUTTON SECTION */}

        {/* {"OFF"+String(isAllMetricsTurnedOff)+'-'+String(isAllTableTurnedOff)} <br />
        {"CHANGE"+String(metricListChangeDetect)+'-'+String(tableListChangeDetect)} */}

        {fetchTableListSetting.loading || saveTableListSetting.loading ? <div className="d-flex align-items-center justify-content-center chart-overlay position-absolute hei-60 f-w-700 text-dark w-100 h-100">
          <Loader />
        </div> : null}

        <div className="d-flex align-items-center gap-20 px-3 pt-2 pb-2 bg-white">
          <RadioButton
            classes="f-10"
            title="Metrics"
            id="metrics"
            radioname="target_table_settings"
            value="metrics"
            action={handleRadioChange}
            checked={selectedOption === 'metrics'}
          />
          <RadioButton
            classes="f-10"
            title="Tables"
            id="tables"
            radioname="target_table_settings"
            value="tables"
            checked={selectedOption === 'tables'}
            action={handleRadioChange}
          />
        </div>
        {/* RADIO BUTTON SECTION */}

        {/* CONTENT SECTION */}
        <section className="max-hei-291 overflow-auto px-3 pb-2 bg-white">
          {/* METRICS LIST */}
          {/* {selectedOption === 'metrics' && (
            <DndProvider backend={HTML5Backend}>
              <ul className="d-flex flex-column gap-2">
                <DroppableContainer onDrop={handleDropMetrics}>
                  {metricsList.map((column) => (
                    <DraggableItem
                      key={`metric_${column.title}`}
                      rightDrag="true"
                      itemId={`table_column_${column.title}`}
                      content={
                        <li key={column.title}>
                          <CheckBox classes="f-10" label={column.title} id={column.title} />
                        </li>
                      }
                    />
                  ))}
                </DroppableContainer>
              </ul>
            </DndProvider>
          )} */}

          {selectedOption === 'metrics' ? <MetricsDrag metricsList={metricsList} updateMetricsList={updateDataToMetrics} /> : null}
          {/* METRICS LIST */}

          {/* TABLE LIST */}
          {/* {selectedOption === 'tables' && (
            <DndProvider backend={HTML5Backend}>
              <DraggableItem itemId="1" content={<TableAccordion title="Target Table" listData={['Item 1', 'Item 2', 'Item 3']} />} />
            </DndProvider>
          )} */}
          {(selectedOption === 'tables' && !isAmazonTargeting) && <TablesDrag tablesList={tablesList} updateTablesList={updateDataToTables} /> }
          {(selectedOption === 'tables' && isAmazonTargeting) && <CustomTablesDrag tablesList={tablesList} updateTablesList={updateDataToTables} setCustomTableAlert={setCustomTableAlert} />}
          {/* TABLE LIST */}
        </section>
        {/* CONTENT SECTION */}

        {/* FOOTER SECTION */}
        {selectedOption == 'metrics' ? <div className="settings_table_footer bg-white">
          <p className={`comple-btn w-fit p-2 f-12 ${fetchTableListSetting.loading || saveTableListSetting.loading ? 'disabled' : isAllMetricsTurnedOff ? 'disabled' : metricListChangeDetect ? '' : 'disabled'}`} onClick={onUpdateSettings}>Apply</p>
          <p className="cls-btn mt-0 p-2 f-12 f-w-400 rounded-4 cursor-pointer" onClick={handleClose}>Cancel</p>
        </div> : <div className="settings_table_footer bg-white">
          <p className={`comple-btn w-fit p-2 f-12 ${fetchTableListSetting.loading || saveTableListSetting.loading ? 'disabled' : tableListChangeDetect ? '' : isAllTableTurnedOff ? 'disabled' : 'disabled'}`} onClick={onUpdateSettings}>Apply</p>
          <p className="cls-btn mt-0 p-2 f-12 f-w-400 rounded-4 cursor-pointer" onClick={handleClose}>Cancel</p>
        </div>}
        {/* {String(tableListChangeDetect)+'-'+String(isAllTableTurnedOff)} <br /> */}
        {/* FOOTER SECTION */}
      </Popover>

      <LogoutModal show={showModal} onHide={handleCloseModal} handleDeleteApi={handleDeleteApi} loading={deleteApiCall.loading}   />
    </div>
  );
}

const TableAccordion = ({ title, listData }) => {
  const [showList, setShowList] = useState(false);
  return (
    <section className="d-flex flex-column w-100">
      <div className="d-flex align-items-center gap-10 f-12 f-w-400 cursor-pointer text-dark" onClick={() => setShowList(!showList)}>
        <img src={showList ? DownArrow : RightArrow} alt="table-collapse" />
        {title}
      </div>
      <Collapse in={showList}>
        <div id="example-collapse-text">
          <ul className="d-flex flex-column gap-2 pt-3 pl-3 w-100">
            {listData.map((item, index) => (
              <li key={index}>
                <DraggableItem itemId="1" rightDrag="true" content={<CheckBox classes="f-10" label={item} id={item} />} />
              </li>
            ))}
          </ul>
        </div>
      </Collapse>
    </section>
  );
};


const LogoutModal = ({ show, onHide, handleDeleteApi, loading }) => {


  return (
<Modal className="asin-modal" dialogClassName="new-theme" show={show} onHide={onHide} centered>
  <Modal.Body className="pt-4 " style={{ borderTopLeftRadius: '16px', borderTopRightRadius: '16px' }}>
    <p className="f-16 f-w-600 py-1 text-center" style={{lineHeight: '27px'}}>Are you sure you want to reset all the tables and metrics by default?</p>
  </Modal.Body>
  <Modal.Footer className="gap-10 border-none justify-content-center pb-4">
    <Button className="btn f-14 cls-btn py-2 px-3 f-13 border-none" onClick={onHide} disabled={loading}>
      Cancel
    </Button>
    <Button className="btn f-14 bg-blue text-white py-2 px-3 f-13 border-none d-flex align-items-center gap-10" onClick={handleDeleteApi} disabled={loading}>
      Yes
      {loading && (
        <Spinner animation="border" role="status" className="wid-15 hei-15" />
      )}
    </Button>
  </Modal.Footer>
</Modal>
  );
};